// extracted by mini-css-extract-plugin
export default {"reverted-backdrop":"CompareCSO_reverted-backdrop__OMijJ","modal-content":"CompareCSO_modal-content__8PFcp","modal-header":"CompareCSO_modal-header__fRvgT"};